export type PageLang = 'EN' | 'TH'

const STORAGE_KEY = 'loginPageLang'

export const getStoredPageLang = (): PageLang => {
  const stored = window.localStorage.getItem(STORAGE_KEY)
  return stored === 'EN' || stored === 'TH' ? stored : 'TH'
}

export const setStoredPageLang = (lang: PageLang) => {
  window.localStorage.setItem(STORAGE_KEY, lang)
}
